import { SectionDescription, SectionTitle } from '@/features/app-shell/section'

import type { ReactNode } from 'react'

/**
 * Log Search's title and description. Static chrome: the route and its
 * `pendingComponent` both render this one, so the header cannot shift when
 * the page resolves.
 *
 * `action` is the right-hand slot. The page passes the Ask Noah trigger; the
 * skeleton passes nothing. The trigger carries the demo tour's `ask-noah`
 * anchor, and a copy in the skeleton would let the tour spotlight a node that
 * unmounts when the page resolves. The button is shorter than the title
 * block, so leaving it out does not change the header's height.
 */
export const SearchPageHeader = ({ action }: { action?: ReactNode }) => (
	<div className="flex w-full items-start justify-between gap-4">
		<div className="flex flex-col gap-1">
			<SectionTitle>Search</SectionTitle>
			<SectionDescription>
				Search, filter, and investigate log data across your connected
				integrations to quickly identify suspicious activity and security
				events.
			</SectionDescription>
		</div>
		{action}
	</div>
)
